var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 358,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 844.64 987.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 108.37,
    cy: 447.7,
    fx: 108.37,
    fy: 447.7,
    r: 103.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ecbb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#edc01e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f1cf55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f8e7aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#eaface"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1f494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#bdef66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#aeec45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a6ea31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 372.4,
    y1: 362.28,
    x2: 375.13,
    y2: 514.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5c6472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#606875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#89909b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a9afb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c1c5cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cfd3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d4d8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#bfc3cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#898f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#565e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#333a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1d2433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#151c2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 360.72,
    y1: 831.05,
    x2: 434.99,
    y2: 669.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2d4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4a6e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#79af37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 403.25,
    y1: 741.73,
    x2: 400.31,
    y2: 783.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ecbb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6ae09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#999e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#789209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#648b09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d8909"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 110.62,
    cy: 445.02,
    fx: 110.62,
    fy: 445.02,
    r: 70.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ecbb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#edc01e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f1cf55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f8e7aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eaface"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d1f494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#bdef66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#aeec45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a6ea31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 69.78,
    y1: 385.71,
    x2: 67.66,
    y2: 509.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 95.07,
    y1: 117.98,
    x2: 185.82,
    y2: 117.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e4f8c0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ccf38b",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#baef61",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#adec43",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a5ea30",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 357.31,
    y1: 185.37,
    x2: 348.49,
    y2: 69.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 152.76,
    y1: 86.94,
    x2: 314.43,
    y2: 86.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5c6472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#606875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#89909b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a9afb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#c1c5cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cfd3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d4d8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#bfc3cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#898f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#565e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525a6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 240.1,
    y1: -0.42,
    x2: 291.1,
    y2: 130.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d4d8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#bfc3cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#898f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#565e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525a6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 290.2,
    y1: 129.96,
    x2: 215.63,
    y2: -39.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 294.65,
    y1: 146.22,
    x2: 293.52,
    y2: 72.75,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 292.65,
    y1: 146.25,
    x2: 291.52,
    y2: 72.78,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 289.52,
    y1: 146.3,
    x2: 288.39,
    y2: 72.83,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 284.91,
    y1: 146.37,
    x2: 283.78,
    y2: 72.9,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 3.87
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a3ea2a",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 167.07,
    y1: 52.11,
    x2: 308.13,
    y2: 177.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9de22b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#78ae37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#598341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#416149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2f494f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#253b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 265.37,
    y1: 92.92,
    x2: 351.82,
    y2: 284.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2a59be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#02adef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 282.26,
    y1: 401.43,
    x2: 308.63,
    y2: 224.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0c87bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#156490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1c4b6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#203b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 381.86,
    y1: 348.22,
    x2: 406.18,
    y2: 348.22,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 340.88,
    y1: 171.88,
    x2: 84.47,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2a59be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#02adef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 90.02,
    y1: 306.78,
    x2: 273.77,
    y2: 5.51,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 272.45,
    y1: 301.84,
    x2: 346.99,
    y2: 301.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a59be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2a59be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 298.4,
    y1: 191.51,
    x2: 274.73,
    y2: 114.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0c87bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#156490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1c4b6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#203b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 327.96,
    y1: 254.34,
    x2: 302.81,
    y2: 159.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0798d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0e7eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#146794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#19557c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1d476a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#203d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#213756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "G",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 3.01
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c7fffd",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "H",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 3.01
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c7fffd",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "I",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 3.01
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c7fffd",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "J",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 3.01
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c7fffd",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 298.08,
    y1: 302.21,
    x2: 459.25,
    y2: 124.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2a59be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#02adef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 91.99,
    y1: 352.01,
    x2: 184.88,
    y2: 352.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5c6472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#606875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#89909b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a9afb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c1c5cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cfd3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d4d8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#bfc3cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#898f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#565e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525a6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 110.71,
    y1: 359.57,
    x2: 184.88,
    y2: 359.57,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 84.74,
    y1: 350.35,
    x2: 117.31,
    y2: 544.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 362.5,
    y1: 421.22,
    x2: 237.97,
    y2: 471.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2d4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4a6e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#79af37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 114.57,
    y1: 474.94,
    x2: 242.47,
    y2: 548.49,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "O",
    cx: 287.49,
    cy: 502.78,
    fx: 287.49,
    fy: 502.78,
    r: 133.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2d4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4a6e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#79af37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 242.27,
    y1: 588.47,
    x2: 159.37,
    y2: 430.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 230.69,
    y1: 594.56,
    x2: 147.79,
    y2: 436.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 204.37,
    y1: 571.84,
    x2: 121.47,
    y2: 414.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 205.69,
    y1: 607.71,
    x2: 122.79,
    y2: 450.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 154.21,
    y1: 638.17,
    x2: 268.33,
    y2: 534.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2d4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4a6e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#79af37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 189.25,
    y1: 721.43,
    x2: 474.66,
    y2: 533.31,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 360.95,
    y1: 692.88,
    x2: 322.5,
    y2: 863.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#d4d8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#bbc0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8e94a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6d7482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#596170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525a6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 380.32,
    y1: 749.57,
    x2: 381.31,
    y2: 882.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "U",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 3.87
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ecff33",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 480.87,
    y1: 643.6,
    x2: 542.55,
    y2: 577.8,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 341.27,
    y1: 436.5,
    x2: 473.99,
    y2: 436.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2d4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4a6e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#79af37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 361.12,
    y1: 564.12,
    x2: 539.99,
    y2: 564.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5c6472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#606875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#89909b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a9afb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#c1c5cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#cfd3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d4d8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#bfc3cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#898f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#565e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525a6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 477.02,
    y1: 499.18,
    x2: 322.63,
    y2: 582.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2b4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4f7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6d9f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#84bf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#95d72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9fe52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 487.78,
    y1: 519.19,
    x2: 333.39,
    y2: 602.17,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 498.35,
    y1: 538.86,
    x2: 343.96,
    y2: 621.84,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 508.26,
    y1: 557.29,
    x2: 353.87,
    y2: 640.27,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 521.17,
    y1: 752.24,
    x2: 845.5,
    y2: 540.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2d4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4a6e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#79af37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 646.27,
    y1: 773.81,
    x2: 691.85,
    y2: 910.11,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 671.3,
    y1: 877.16,
    x2: 715.62,
    y2: 687.89,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 688.6,
    y1: 798.01,
    x2: 687.6,
    y2: 980.67,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "af",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 3.87
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ecff33",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 262.15,
    y1: 171.78,
    x2: 206.44,
    y2: 202.66,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 109.41,
    y1: 437.8,
    x2: 39.61,
    y2: 476.49,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 151.1,
    y1: 430.2,
    x2: 43.92,
    y2: 489.61,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 123.42,
    y1: 421.39,
    x2: 120.19,
    y2: 610.35,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 518.19,
    y1: 385.56,
    x2: 602.27,
    y2: 385.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#233853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2a4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#35504d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#446648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#588142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#70a43a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8dcb31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 424.12,
    y1: 312.91,
    x2: 597.49,
    y2: 312.91,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 441.28,
    y1: 313.73,
    x2: 538.76,
    y2: 313.73,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "an"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 898.47,
    y1: 738.59,
    x2: 282.68,
    y2: 165.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f5dd85",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#eec42c",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ecbb0a",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#eba90e",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#eb751a",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eb4a25",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#eb292d",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#eb1132",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eb0435",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#eb0037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ap",
    "data-name": "AI_GaussianBlur_4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 326.96,
    y1: 840.44,
    x2: 326.96,
    y2: 228.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f5dd85",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#eec42c",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ecbb0a",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#eba90e",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#eb601f",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#eb2b2c",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#eb0b34",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#eb0037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ar",
    "data-name": "AI_GaussianBlur_4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 623.25,
    y1: 714.43,
    x2: 313.89,
    y2: 88.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f5dd85",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#eec42c",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ecbb0a",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#eba90e",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#eb601f",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#eb2b2c",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#eb0b34",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eb0037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "at",
    "data-name": "AI_GaussianBlur_4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 527.39,
    y1: 761.83,
    x2: 218.02,
    y2: 136.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f5dd85",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#eec42c",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ecbb0a",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#eba90e",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#eb601f",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#eb2b2c",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#eb0b34",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#eb0037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 211.33,
    y1: 329.18,
    x2: 194.28,
    y2: 276.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f9eab5",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f4d978",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f0cc48",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#eec226",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ecbd11",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecbb0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 459.15,
    y1: 275.86,
    x2: 417.1,
    y2: 236.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f9eab5",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f4d978",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f0cc48",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#eec226",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ecbd11",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ecbb0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 312.7,
    y1: 348.29,
    x2: 302.09,
    y2: 289.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f9eab5",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f4d978",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f0cc48",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eec226",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ecbd11",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ecbb0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 444.48,
    y1: 347.8,
    x2: 398.96,
    y2: 294.75,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 360.39,
    y1: 545.82,
    x2: 131.7,
    y2: 279.37,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 631.12,
    y1: 469.79,
    x2: 407.75,
    y2: 209.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f9eab5",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f4d978",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f0cc48",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#eec226",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ecbd11",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecbb0a"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.27 504.5s37.82 8.03 67.55-7.05c29.73-15.07 44.98-39.56 41.54-73.92-3.44-34.36-22.83-59.43-38.58-63.97l-5.61-1.1-.95 6.32s41.29 12.03 32.94 64.7c-8.34 52.68-47.17 54.51-79.91 64.7l-10.64 3.26-6.35 7.05Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.37,
    cy: 447.7,
    r: 71.73,
    style: {
      fill: "url(#n)",
      filter: "url(#outer-glow-1)",
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.41,
    y: 695.4,
    width: 74.54,
    height: 86.55,
    transform: "translate(-387.97 380.28) rotate(-38.95)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.81 802.49 653.53 854.03 682.31 768.87 641.61 720.93 616.81 802.49",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.95,
    y: 227.04,
    width: 168.8,
    height: 168.8,
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.23 364.79s43.15 11.5 32.05 70.13c-11.1 58.63-80.01 59.27-80.01 59.27s16.75-36.42 10.08-64.7c-6.67-28.29-21.35-39.4-21.35-39.4s-33.63-17.87-40.83-19.38c-7.19-1.51 100.07-5.93 100.07-5.93Z",
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.38 755.34c-9.45.43-33.89 12.44-39.38 32.66 0 0 0-1-1.11.88-.83 1.88-.52 3.81-1.03 5.76-.13.49-1.26.98-1.41 1.48-2.79 7.25-7.03 16.24-11.53 25.17-.79-1.02-2.23-2.88-4.81-6.22-5.8-7.49-.64-29.23 5.8-53.93 6.44-24.7 26.2-27.06 26.2-27.06 6.44 6.87 27.27 21.26 27.27 21.26Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.92 821.29c4.5-8.92 8.74-17.92 11.53-25.17-2.58 9.13-6.84 18.77-10.6 26.36-.39.78-.77 1.55-1.15 2.28-3.44 6.77-6.23 11.47-6.5 11.93l-.02.04-14.05 22.96-.02.04c-4.55 4.85-7.4 9.45-9.13 13.63-5.1 12.35-.31 20.97-.21 21.15s-10.31-3.65-13.96-13.66c-3.65-10.01 0-37.67 0-48.62s-12.03-39.09-13.31-43.6 0-7.73 0-7.73l20.4 3.01 30.5-56.7 15.17-3.65 7.17-1.72.17.19s.07.08.11.12c1.14 1.23 5.56 6.03 11.1 11.93 0 0-19.76 2.36-26.2 27.06-6.44 24.7-11.6 46.43-5.8 53.93 2.59 3.34 4.02 5.2 4.81 6.22Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.38 755.34c-13.72 2.9-33.01 16.58-40.49 33.53 5.49-20.22 31.04-33.1 40.49-33.53Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.04 604.46s-16.97-25.84-21.57-47.21c-3.04-14.11 10.16-26.55 23.97-22.35 3.1.94 5.83 2.63 7.6 5.47l26.25 48.3-36.25 15.79Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.77 589.76s-11.24-.21-12.1 8.17c0 0 46.62 32.39 109.33 22.08 0 0 34.34-8.12 42.29-12.84 0 0-25.46-32.4-57.18-38.32l-82.34 20.92Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.62,
    cy: 445.02,
    r: 49.18,
    style: {
      fill: "url(#q)",
      filter: "url(#outer-glow-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.85 395.77s-20.25 8.44-22.4 13.16c-2.15 4.72-12.67 16.49-12.67 21.05s-.21 10.31 5.58 9.02c5.8-1.29 7.25-4.3 7.25-4.3s9.37-13.42 14.91-18.84 7.33-20.09 7.33-20.09Z",
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37 86.94s-8 43.41-2.49 67.06l37.56-8.14-21.96-63.91-13.11 4.99Z",
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.76 134.12s17.07-11.89 41.8-4.16c24.73 7.73 29.89 35.47 29.89 35.47s-64.56-14.06-71.69-31.32Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.83 134.26-64.43 8.16-12.46 3.44s-18.59 6.64-34.05 5.61c-4.2-.28-8.17-1.12-11.48-2.82-6.92-3.56-10.15-11.29-11.45-19.52v-.01l-.18-1.23v-.05c-1.33-9.77-.11-19.96.69-24.51 1.5-8.59 1.48-16.68-7.1-16.39 0 0-8.86 4.18-9.57-2.38-.27-2.56.88-5.06 2.94-6.59 1.68-1.25 4.09-3.09 6.71-5.26 4.5-3.7 9.63-8.35 12.81-12.55 6.66-8.81 31.78-42.31 75.17-37.37 43.38 4.94 58.41 38.01 61.42 48.96s6.44 40.59-9.02 62.49Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.76 50.32s19.87 20.8 14.72 47.43-20.4 42.09-20.4 42.09l51.97-4.08S337 89.5 293.93 42.62l-37.17 7.7Z",
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.95 31.4s34.46-13.53 55.51 10.95c21.05 24.48 18.04 52.83 18.04 52.83s18.42-2.58 26.07 0c0 0 .9-48.04-35.99-67.51 0 0-31.94-14.09-63.62 3.73Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.57 105.05 281.57 111.52 305.43 111.52 306.56 105.05 281.57 105.05",
    style: {
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.76 114.5 302.4 119.87 279.64 119.01 280.93 114.5 304.76 114.5",
    style: {
      fill: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.33 122.88 299.39 128.03 277.06 126.75 278.99 122.24 301.33 122.88",
    style: {
      fill: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.4 134.66 297.25 131.26 274.7 129.97 272.16 134.66 284.17 135.27 295.4 134.66",
    style: {
      fill: "url(#x)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.46,
    cy: 96.79,
    rx: 41.99,
    ry: 51.86,
    style: {
      fill: "#a3ea2a",
      filter: "url(#y)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.46,
    cy: 96.79,
    rx: 38.55,
    ry: 47.62,
    style: {
      fill: "url(#z)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.91 151.47h-.01c-4.2-.28-8.17-1.12-11.48-2.82-6.92-3.56-10.15-11.29-11.45-19.52v-.01l-.18-1.23v-.05c-1.33-9.77-.11-19.96.69-24.51 1.5-8.59 1.48-16.68-7.1-16.39 0 0-8.86 4.18-9.57-2.38-.27-2.56.88-5.06 2.94-6.59 1.68-1.25 4.09-3.09 6.71-5.26 0 0 9.97 7.71 10.31 14.23.34 6.51-3.74 25.41-1.59 33.79s1.51 21.1 20.73 30.74Z",
    style: {
      fill: "#223654",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.74 134.12-93.39 7.1s5.62 41.36 40.81 81.52C307.34 262.9 386.37 335.7 386.37 335.7h19.81s-8.64-99.22-36.77-143.46c-28.13-44.24-44.67-58.12-44.67-58.12Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.35 141.22-5.4 4.64s1.7 45.02 27.91 81.25 121.13 127.07 128.01 129l4.51-20.4s-144.96-129.5-155.02-194.48Z",
    style: {
      fill: "url(#A)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.18 335.7v22.77s-12.93 6.44-24.32-2.37l4.51-20.4h19.81Z",
    style: {
      fill: "url(#B)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.86 227.11s6.24 56.53 5.59 70.64c-.64 14.12-5.14 19.18-5.14 19.18l-5.17-8.07s4.94-6.1 2.36-11.53c-2.58-5.43-16.32-16.17-45.1-11.66s-44.25 21.45-42.31 31.57c2.15 11.17 4.3 13.1 4.3 13.1l2.79 9.45s-11.6 1.07-18.04-24.48c-6.44-25.56-13.96-58.41-6.66-84.61 0 0 6.66-9.45 11.38-17.82 4.72-8.38 3.01-26.42 19.33-42.09s26.46-19.73 26.46-19.73l22.29-5.18s15.46 62.49 27.91 81.25Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45 234.91s-19.15-23.55-5.62-54.05c13.53-30.5 30.93-32.21 39.09-35.01s35.57 2.66 35.57 2.66-15.11 4.85-37.49 30.48c0 0-11.13 15.26-15 29-3.87 13.74-15.51 22.69-15.51 22.69l-1.04 4.23Z",
    style: {
      fill: "url(#C)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43 300.74s-6.98-67.26 7.62-104.63c0 0 .01 22.11 6.76 38.76s3.36 55.44 3.36 55.44-13.77 5.74-17.75 10.43Z",
    style: {
      fill: "#2a59be",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.99 285.12-49.94-89.01s-.05 40.89 1.58 57.17l8.54 37.03s22.32-7.45 39.81-5.19Z",
    style: {
      fill: "#02adef",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.3 288.83 9.55 20.45s3.65-5.02.64-11.96c-3.01-6.94-10.2-8.49-10.2-8.49ZM406.18 358.47s1.5 23.97-12.16 23.58-73.8-17-135.54-106.41l-4.62-48.53s90.85 106.24 128.01 129c0 0 7.83 7.53 24.32 2.37Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.54 270.85s-15.25-7.73-22.33 2.15c-7.09 9.88-8.11 19.97-5.34 36.29 0 0 3.19-11.6 24.88-7.09 21.69 4.51 34.58 10.74 41.02 22.76L343 335.7s11.66.43-4.91-26.42-36.55-38.44-36.55-38.44Z",
    style: {
      fill: "url(#D)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.86 144.41 12.9 17.99 52.01-2.34-12.2-18.84s-34.04-4.28-52.71 3.18Z",
    style: {
      fill: "url(#E)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.38 173.13s33.32 46.04 48.33 56.85l56.01-2.87S349.51 165.5 318.76 140l-3.08 1.22s16.78 21.17 20.65 32.34l-74.95-.43Z",
    style: {
      fill: "url(#F)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.3 189.03 350.7 186.15 352.95 191.19 276.49 193.15 273.3 189.03",
    style: {
      fill: "#0ff",
      filter: "url(#G)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.85 203.64 356.22 199.07 358.4 204.71 289.32 209.04 284.85 203.64",
    style: {
      fill: "#0ff",
      filter: "url(#H)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.17 220.18 362.18 215.44 363.7 220.18 303.48 224.58 299.17 220.18",
    style: {
      fill: "#0ff",
      filter: "url(#I)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.4 177.25 345.34 175.28 342.49 170.09 261.38 173.13 264.4 177.25",
    style: {
      fill: "#0ff",
      filter: "url(#J)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.04 139.33s19.86.4 29.83 5.07c9.97 4.67 7.93 11.12 22.37 17.99s37.4 6.48 58.67 23.75c21.27 17.27 34.47 48.77 34.47 48.77s-20.15-5.51-31.17 7.91c-11.02 13.42-24.63 32.43-19.43 46.01l-28.63-19.39s-7.41-48.85-26.74-77.2-39.36-52.91-39.36-52.91Z",
    style: {
      fill: "url(#K)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.61 301.84-9.84-13-28.63-19.39 2.75 14.14s22.76 20.37 28.96 21 6.76-2.74 6.76-2.74Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.37 234.91s4.6 9.86 0 20l-4.9-6.25s5.76-11.84-7.06-14.8c0 0 7.55-.31 11.96 1.05Z",
    style: {
      fill: "#02adef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.79 234.91 13.68 13.75s2.93-7.32-.75-11.47-6.32-3.33-6.32-3.33l-6.62 1.05Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.49 272.54 370 192 394.02 258.12 420.41 294.58 425.49 272.54",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46 239.58s-24.79-52.27-57.01-59.58c0 0 33.06-1.86 46.81 3.36 0 0 15.23 6.16 38.11 51.54 0 0-13.86-4.05-27.92 4.67Z",
    style: {
      fill: "#02adef",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.83 292.43-37.12 59.58-18.72 30.05s.17 19.36 22.07 25.81c21.91 6.44 35.86 2.58 35.86 2.58s2.43-4.1 7.55-9.49c5.7-6 14.72-13.59 27.41-18.89l-12.49-46.35s-14.21 5.15-24.57-43.28Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.71 352.01s10.93 42.88 46.76 48.94c0 0 16.85-14.84 27.41-18.89l-2.77-10.29s-29.61 5.15-50.33-53.58l-21.07 33.82Z",
    style: {
      fill: "url(#L)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.19 364.06 118.32 339.79 122.76 332.66 120.33 373.69 115.19 364.06",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.59 386.76 137.62 332.66 143.48 343.89 138.44 393.25 130.59 386.76",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.85 399.65 4.74-38.9s3.27 2.99 5.07 4.22l-4.19 35.98-5.62-1.3ZM171.17 390.1l1.76-19.38 4.29.95-1.6 15.39s-4.68.95-4.45 3.04Z",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.99 382.06-4.13 9.91s.77 10.87 24.05 19.54c20.19 7.52 35.89 3.01 35.89 3.01l2.13-4.08s-52.52 5.73-57.94-28.38Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08 482.24c1.93 11.55.91 14.55-6.7 14.87-1.19.05-2.53.03-4.05-.02-6.51-.25-7.09-36.61-12.03-38.33-3.93-1.37-4.39 25.7-4.42 36.77-.02 6.03-6.67 9.8-11.76 6.57-.47-.3-.91-.54-1.01-.82-.7-2.03-.92-8.3-1.04-15.67-.13-8.17-.13-17.69-.53-24.29-.28-4.77-.77-8.02-1.66-8.14-2.58-.34-12.2 27.17-15.91 38.11-2.19 6.45-12.79 4.58-15.43-1.19-.77-1.67-.87-3.67.1-5.89.05-.13.63-1.8.64-1.93.5-6.06 14.78-32.21 11.06-33.82-3.82-1.66-8.59 21.69-16.97 25.77-4.89 2.38-8.98.52-11.58-2.44-1.85-2.1-2.94-4.75-3.03-6.8-.21-4.94 6.23-16.54 11.38-27.27 5.15-10.74 5.58-11.38 13.74-21.85s10.95-23.89 10.95-23.89c15.89 28.35 59.94 22.55 59.94 22.55.09 20.51-7.32 33.07-7.75 35.86s4 19.69 6.03 31.86Z",
    style: {
      fill: "url(#M)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27 504.5c-4.38 4.48-9.61 9.36-15.41 14.43-17.56 5.83-41.83-24.74-41.83-24.74-56.38 26.42-81-29.23-81-29.23s52.66-80.78 73.23-91.27c20.57-10.5 70.82-4.27 82.84 33.96 12.03 38.23 10.52 67.86-17.82 96.86Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.86 518.93-.05.04c-2.39 2.09-4.87 4.2-7.43 6.34l-.07.05s-.07.06-.1.09c-31.4 26.15-74.18 54.77-92.26 59.05-23.19 5.48-61.5 14-69.19-18.39-6.47-27.24 30.65-80.17 42.64-96.34 2.01-2.71 3.31-4.39 3.58-4.74l.05-.07s24.62 55.65 81 29.23c0 0 24.27 30.57 41.83 24.74Z",
    style: {
      fill: "url(#N)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.86 518.93-.05.04-7.43 6.34-.07.05-.1.09c-.33-.05-29.16-4.31-35.35-24.6 0 0-58.91 32.32-83.47-31.09l3.58-4.74.05-.07s24.62 55.65 81 29.23c0 0 24.27 30.57 41.83 24.74Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.83,
    cy: 456.72,
    r: 28.88,
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.83,
    cy: 456.72,
    r: 21.8,
    style: {
      fill: "url(#O)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.23 485.6 7.01 27.7s6.87-12.03 0-27.7l-2.8-6.16-4.21 6.16Z",
    style: {
      fill: "url(#P)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.16 498.15 185.79 527.27 191.8 519.11 185.26 490.1 180.16 498.15",
    style: {
      fill: "url(#Q)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.96 503.47 183.21 529.84 176.96 535.98 172.08 512.06 176.96 503.47",
    style: {
      fill: "url(#R)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7 518.5s1.71 19.15 3.39 22.01c0 0-5.2 3.16-12.28-1.18 0 0 5.55-14.35 8.9-20.83Z",
    style: {
      fill: "url(#S)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.67 585.94s1.99 14.13-10.47 17.78c0 0-16.38 5.57-20.97-13.96 0 0 27.73-2.91 31.44-3.81Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1 694.78s-12.46-4.3-22.33 9.02-3.01 56.05-13.91 67.37c-10.9 11.32-25.82 1.99-25.82 1.99s-4.48-4.87-11.82-12.88c-32.61-35.6-121.56-133.24-124.54-142.22-3.65-11 0-20.14 0-20.14 12.51 6.27 24.67 10.87 36.31 14.16 66.09 18.68 115.31-4.92 115.31-4.92 18.45 23.15 36.64 63.6 43.72 80.19 1.98 4.65 3.09 7.43 3.09 7.43Z",
    style: {
      fill: "url(#T)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.49 780.9s23.84 4.94 27.06-36.08c3.22-41.02 7.95-49.39 21.48-47.46 13.53 1.93 24.7 24.48 24.7 24.48s-29.21.86-30.71 51.54-11.81 40.37 8.16 63.35l-14.07 22.99s-20.72-7.96-16.21-38.03c4.51-30.07-20.4-40.8-20.4-40.8Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1 734.08s-19.76 2.36-26.2 27.06c-6.44 24.7-11.6 46.43-5.8 53.93 2.59 3.34 4.02 5.2 4.81 6.22.6.78.84 1.08.93 1.2l.06.08-1.2 2.21-6.5 11.93-.02.04s-.42-.1-1.11-.38c-3.56-1.44-14.22-7.73-9.87-30.28 5.18-26.9-2.17-38.52 7.2-59.34 7.08-15.74 12.37-20.81 19.17-23.18 2.19-.77 4.55-1.25 7.17-1.72l.17.19.11.12 11.1 11.93Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.6 767.58c-.92 9.41-8.43 24.53-21.65 38.14-4.52 4.65-7.2 10.77-7.45 17.25-.23 6.15 1.54 13.59.96 18.49-2.15 18.24-35.65 60.33-62.71 53.03-.12-.15-6.15-7.38.21-21.15 1.85-4 4.74-8.55 9.13-13.63 0 0 0-.01.02-.04.39-.68 6.15-10.67 12.94-23.33 2.55-4.76 5.25-9.91 7.85-15.07 4.5-8.92 8.74-17.92 11.53-25.17.57-1.49.99-3.84 1.25-5.63.36-2.54 1.01-5.04 2.09-7.38 7.99-17.26 30.93-27.38 39.59-27.78 0 0 7.3 1.29 6.23 12.24Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.46 827.93c1.28-3.8 2.57-7.61 3.85-11.41 1.32-3.9 2.63-7.8 4.3-11.57 2.03-4.58 4.57-8.92 7.37-13.08 6.42-9.53 14.52-18.36 24.98-23.12 1.11-.5 2.56-.9 3.41-.03.95.98.25 2.6-.49 3.75-5.2 7.95-11.29 15.28-16.54 23.2s-9.7 16.6-11.08 26c-1.06 7.21-.3 14.72-2.54 21.65-2.3 7.15-7.55 12.94-12.96 18.17-8.27 8-23.36 29.48-30.66 26.68-6.34-2.43-3.32-9.92-3.01-11.38 1.01-4.69 19.84-31.35 27.46-40.9 2.15-2.69 4.22-4.09 5.94-7.96",
    style: {
      fill: "none",
      filter: "url(#U)",
      stroke: "#a3ea2a",
      strokeMiterlimit: 10,
      strokeWidth: ".86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1 694.78s-12.46-4.3-22.33 9.02-3.01 56.05-13.91 67.37c-10.9 11.32-25.82 1.99-25.82 1.99s-4.48-4.87-11.82-12.88 18.05 5.15 31.15 0c13.1-5.15 7.52-55.62 14.69-68.62 7.18-12.99 24.95-4.31 24.95-4.31 1.98 4.65 3.09 7.43 3.09 7.43Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14 495.38S347.07 503.19 342 504c0 0 29.52-30.65 22.99-71.88 0 0-6.47-26.64-8.12-30.28 0 0 12.62 20.4 13.02 43.82.48 27.81-8.75 49.72-8.75 49.72ZM539.99 591.16s38.73 7.6 37.01 16.84-58.98 12.9-70.79 19.56c-11.81 6.66-13.53 15.89-20.83 16.11l-7.3.21s10.99-11.8 13.33-24.05c2.35-12.25.77-40.15 48.59-28.67Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.74 591.68s30.88-2.02 25.62 29.6c0 0-25.25 1.32-30.61 10.89 0 0-11.53-5.79-12.34-14.16-.81-8.37 1.26-18.19 17.33-26.33Z",
    style: {
      fill: "url(#V)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.27 504.5 15.46 12.46s47.75.94 64.78-13.49c17.04-14.43 19.82-42.4 52.47-38.51 0 0-6.78-71.45-33.88-91.34-27.1-19.88-29.58-17.52-29.58-17.52l-4.34 2.37S433.5 363.34 445 405c11.51 41.66-5 68-20.39 79.5-15.02 11.22-33.61 22.5-83.34 20.01Z",
    style: {
      fill: "url(#W)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.73 516.96 4.39 6.45s43.1 5.77 61.88-9.41c20.69-16.73 23.93-44.72 50.99-44.29v-4.75S456.07 455.68 440 477c-14.96 19.84-12 30-46 35-27.44 4.04-37.27 4.96-37.27 4.96Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.12 523.41 77.15 81.04s-2 6.54 1.83 12.89c3.82 6.35 38.19 41.57 38.19 41.57s-8.59-9.88 4.51-19.54c13.1-9.66 4.32-32.43 18.27-41.45 13.94-9.02 24.61-10.51 38.93-6.76 0 0-27.18-43.48-36.39-65.72C494.4 503.21 474 469.7 474 469.7s-21.9-6.23-42.63 31.79c0 0-9.8 25.58-70.24 21.91Z",
    style: {
      fill: "url(#X)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.44 537.4s11.5-5.84 24.38 1.89c12.89 7.73 15.03 10.74 15.03 10.74s-24.56-6.2-30.86-3.64l-8.56-8.99Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.45 553.17s27.84 2.45 31.71 4.38l9.36 11.29-28.62-2.59-12.45-13.08Z",
    style: {
      fill: "url(#Y)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.63 572.26 434.05 574.94 439.42 585.9 418.29 583.46 407.63 572.26",
    style: {
      fill: "url(#Z)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.28 589.76 442.64 593.2 442.64 605.23 438.28 604.46 424.28 589.76",
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.56 646.51-38.8-38.21s-.02 10.78 4.77 16.36 35.76 34.25 35.76 34.25-3.66-2.69-1.72-12.4ZM545.43 592.51s22.2-4.25 40.66 8.85c18.47 13.1 31.35 23.62 17.18 36.72s-90.83 2.5-101.37 2.15c-6.91-.23-10.52.64-10.52.64s-2.22-12.9 30.14-18.58c32.36-5.68 62.05-9.42 49.14-20.11l-25.23-9.67Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.32 730.64s-5.98-4.08-16.07-4.08-27.27 20.19-25.34 55.84c1.21 22.26-5.37 33.78-10.48 39.3-3.08 3.32-5.62 4.47-5.62 4.47L478.29 658.91c-6.01-7.3-.21-15.03-.21-15.03s7.3-.21 13.31-3.01c6.01-2.79 22.76-2.15 22.76-2.15 19.64 2.67 35.31 3.78 47.67 3.99 31.3.54 41.45-4.64 41.45-4.64 14.72-15.08-16.73-36.43-17.18-36.72.32.09 20.83 5.85 47.89 39.94 27.27 34.36 40.34 89.34 40.34 89.34Z",
    style: {
      fill: "url(#ab)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.81 826.17s7.49 7.26 16.09 0 3.02-49.14 12.47-65.89c9.45-16.75 13.53-20.19 27.49-16.32l1.47-13.31s-25.09-18.1-34.97 10.31c-9.88 28.41-5.52 36.85-6.31 47.85-.78 11-2.92 28.53-16.24 37.37Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.32 747.75s-14.57-6.8-19.29 6.73c-4.72 13.53-9.45 77.31-24.05 81.39 0 0-6.87 5.37 1.5 18.68s11.17 19.97 8.38 27.92c-2.79 7.95-1.11 17 4.71 21.49s7.96 7.07 7.96 7.07 8.59-24.27 22.76-36.72c0 0-17.82-11.17-16.32-32s-3.22-37.15 4.08-53.47c7.3-16.32 12.67-25.56 25.34-25.99l-15.07-15.1Z",
    style: {
      fill: "url(#ac)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.79 937.02s-4.53-.43-7.63 0c0 0 1.83-33.29 1.83-38.01s-18.9-56.48-24.05-60.99c-5.15-4.51 18.04-2.15 18.04-2.15s-5.37 6.44 1.5 18.68c6.87 12.24 16.67 20.32 7.15 33.57 0 0-1.57 7.67 13.89 22.91 0 0-6.66 12.67-10.74 25.99Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702.92 774.88-13.53-12.03s-26.06-10.28-30.53 38.35c-4.47 48.63-1.25 62.59 17.43 73.11 0 0 6.12-13.85 7.8-39.06 1.7-25.5 15.18-45.55 38.8-44.7l-19.97-15.68Z",
    style: {
      fill: "url(#ad)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.92 774.88s-31.57-4.3-30.5 29.42 3.97 70.12 3.97 70.12-20.62-3.22-19.33-45.02c1.16-37.86-3.54-70.41 29.1-69.77l16.75 15.25Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.79 937.02s-1 25.14 11.58 33.43c.74.49 1.52.91 2.36 1.28 0 0-23.19-.56-21.57-34.7h7.63Z",
    style: {
      fill: "#35aa18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.9 790.56s13.74 3.01 11.6 18.9c-2.15 15.89-10.52 35.42-11.6 45.95-1.07 10.53 4.94 42.31-9.02 65.94-13.96 23.62-33.33 53.73-57.15 50.38-23.81-3.35-15.22-43.08-3.2-60.69 0 0 9.66-27.92 22.76-36.72 0 0 6.44-23.62 8.08-44.91 1.42-18.46 16.41-41.63 38.53-38.84Z",
    style: {
      fill: "url(#ae)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.31 802.8c-7.71 3.04-16.33 11.32-19.11 19.13-5.16 14.47-.46 30.39-6.2 45.17-3.1 7.98-8.24 14.97-13.03 22.07-6.75 10-12.95 20.51-16.67 31.98-3.72 11.47-11.97 29.77-1.41 35.61 11.87 6.57 21.11-3.32 26.67-8.91 12.61-12.66 18.68-30.4 22.32-47.89 3.64-17.49 5.26-35.47 10.87-52.44 3.59-10.87 22.46-48.83-3.43-44.73",
    style: {
      fill: "none",
      filter: "url(#af)",
      stroke: "#a3ea2a",
      strokeMiterlimit: 10,
      strokeWidth: ".86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86 881.16s-10.93-2.33-13.59-10.44c0 0-2.44 16.59 15.49 23.78 0 0-4.13-5.53-1.9-13.34Z",
    style: {
      fill: "#35aa18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.2 603.72 36.05-15.27s3.19-5.09 0-12.2c0 0-16.18 8.45-25.58 9.69 0 0 1.34 13.7-10.47 17.78Z",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.04 139.33s23.25 8.78 38.99 34.34 51.81 74.75 51.81 74.75-9.66 16.09-9.66 28.76c0 15.1 0 0 0 0l-24.48-47.25s-.12-4.17-3.69-11.94c-4.89-10.65-13.66-25.82-13.6-25.75.11.11-39.36-52.91-39.36-52.91Z",
    style: {
      fill: "#151c2b",
      opacity: 0.48
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 160s23.24 38.5 56.86 67.11c0 0-26.73-69.97-27.91-81.25 0 0-16.95.14-28.95 14.14Z",
    style: {
      fill: "url(#ag)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35 448.45c-3.82-1.66-8.59 21.69-16.97 25.77-4.89 2.38-8.98.52-11.58-2.44.05-.77.17-1.58.39-2.45 0 0 21.31-12.76 25.54-24.93s2.62 4.05 2.62 4.05Z",
    style: {
      fill: "url(#ah)",
      opacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55 461.32c-.28-4.77-.77-8.02-1.66-8.14-2.58-.34-12.2 27.17-15.91 38.11-2.19 6.45-12.79 4.58-15.43-1.19 0 0 15.99-10.83 19.21-24.14 3.22-13.31 14.39-45.52 17.61-36.94 1.37 3.66-.41 17.63-3.82 32.3Z",
    style: {
      fill: "url(#ai)",
      opacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38 497.11c-1.19.05-2.53.03-4.05-.02-6.51-.25-7.09-36.61-12.03-38.33-3.93-1.37-4.39 25.7-4.42 36.77-.02 6.03-6.67 9.8-11.76 6.57-.47-.3-.91-.54-1.01-.82-.7-2.03-.92-8.3-1.04-15.67.07.27 3.32 12.11 5.55 6.35 2.25-5.82 8.48-63.59 9.77-54.79s13.23 56.35 16.92 58.03c.95.43 1.61 1.12 2.06 1.91Z",
    style: {
      fill: "url(#aj)",
      opacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.35 762.34-22.13-2.05c-32.61-35.6-121.56-133.24-124.54-142.22-3.65-11 0-20.14 0-20.14 12.51 6.27 24.67 10.87 36.31 14.16l4.03 2.22s58.31 15.32 84.21 50.1c25.89 34.78 22.14 97.94 22.14 97.94ZM622.43 821.7c-3.08 3.32-5.62 4.47-5.62 4.47L478.29 658.91c-6.01-7.3-.21-15.03-.21-15.03s7.3-.21 13.31-3.01c6.01-2.79 22.76-2.15 22.76-2.15 19.64 2.67 35.31 3.78 47.67 3.99 32.28 32.11 62.2 82.62 63.6 116.91.84 20.31-1.05 44.15-3 62.08Z",
    style: {
      fill: "#151c2b",
      opacity: 0.21
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.27 257.6c-2.3-3.17-7.17-5.53-11.65-5.46l-1.59.02c-3.34-4.57-10.15-7.88-16.35-7.83-6.21.04-9.94 3.5-9.02 8.2-4.43.43-6.68 3.49-5.05 7.16 1.74 3.94 7.3 7.06 12.38 6.96l13.63-.29c.71-.04 1.08-.52.79-1.08-.27-.53-1.01-.95-1.71-.95l-13.61.27c-3.63.07-7.6-2.16-8.85-4.96-1.24-2.79.69-5.1 4.32-5.15 1.34-.02 2.8.28 4.16.87.65.28 1.34.23 1.63-.12.33-.39.05-1.02-.63-1.41h-.01a.842.842 0 0 0-.21-.11c-1.35-.58-2.78-.98-4.16-1.15-.5-3.58 2.43-6.19 7.24-6.23 5.1-.05 10.72 2.76 13.28 6.59-.33.17-.65.36-.93.56-.44.33-.29.95.33 1.39.06.04.13.09.2.13.61.34 1.34.36 1.73.07.82-.61 1.99-.95 3.33-.97 3.21-.05 6.69 1.63 8.33 3.89.34.46 1.03.79 1.66.78.72 0 1.1-.46.85-1.01a.59.59 0 0 0-.09-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.11 264.61-1.12.02-1.07-2.34-.17-.38-.18-.42c-.08.1-.17.19-.26.29l-.44.39-.78-.5 1.23-1.07.92-.02 1.86 4.04ZM362.34 262.48c.33.71.41 1.24.26 1.58-.15.34-.54.52-1.17.54-.61.01-1.15-.15-1.63-.5-.48-.34-.87-.86-1.18-1.55-.33-.72-.42-1.25-.28-1.6.14-.35.53-.52 1.16-.54.61-.01 1.15.15 1.63.5.5.35.89.87 1.2 1.55Zm-2.59.06c.23.49.45.85.66 1.07.21.22.46.32.72.31.26 0 .4-.12.42-.34.02-.22-.09-.58-.32-1.08-.23-.5-.45-.86-.67-1.07-.22-.21-.46-.32-.71-.31-.25 0-.4.12-.42.34-.02.22.09.58.32 1.08ZM360.94 270.81l-1.12.03-1.07-2.35-.17-.38-.18-.42c-.08.1-.17.19-.26.29l-.44.39-.78-.5 1.24-1.08.92-.02 1.86 4.05ZM365.2 270.7l-1.12.03-1.07-2.34-.17-.38-.18-.42c-.08.1-.17.19-.26.29l-.44.39-.78-.5 1.24-1.08.92-.02 1.85 4.04h.02ZM369.45 270.58l-1.12.03-1.07-2.33-.17-.38-.18-.42c-.08.1-.17.19-.26.29l-.44.39-.78-.5 1.23-1.08.92-.02 1.87 4.02ZM373.66 268.41c.33.71.42 1.23.26 1.58-.15.35-.54.53-1.17.55-.61.02-1.15-.14-1.63-.49-.48-.34-.87-.86-1.19-1.54-.33-.71-.42-1.24-.28-1.59.14-.35.53-.52 1.16-.54.61-.02 1.15.15 1.63.49.49.34.89.85 1.2 1.54Zm-2.6.07c.23.49.45.85.66 1.06.21.22.45.32.72.31.27 0 .4-.12.42-.34.02-.22-.09-.57-.32-1.07-.23-.49-.45-.85-.67-1.06-.22-.21-.46-.32-.71-.31-.26 0-.4.12-.42.34-.02.22.09.57.32 1.07ZM378.33 273.18c.24.51.3.9.19 1.15-.11.25-.39.39-.85.4-.44.01-.84-.1-1.18-.35-.34-.25-.63-.62-.86-1.12-.24-.52-.3-.9-.2-1.16.11-.25.39-.39.85-.4.44-.01.84.11 1.19.36s.63.62.85 1.11Zm-1.89.06c.17.36.33.62.48.77.12.14.33.23.53.22.2 0 .29-.09.3-.25.01-.16-.06-.42-.23-.77-.16-.36-.33-.62-.49-.77-.16-.15-.33-.23-.52-.23s-.3.09-.3.25.06.42.23.78ZM381.45 274.55l-.84.03-.78-1.68-.12-.28-.12-.3c-.09.11-.16.17-.2.21l-.33.28-.58-.36.94-.78.69-.02 1.35 2.91ZM362.01 273.7c.23.51.29.89.19 1.13-.1.25-.39.38-.84.4-.43.01-.82-.1-1.16-.35-.34-.25-.61-.61-.84-1.1-.23-.51-.29-.89-.19-1.14.1-.25.38-.38.83-.39.43-.01.82.1 1.16.35.34.25.63.62.85 1.11Zm-1.85.05c.16.35.32.61.47.76.11.14.33.23.51.22.19 0 .29-.09.29-.25s-.06-.42-.22-.77c-.16-.35-.32-.61-.48-.76-.15-.15-.32-.23-.51-.22-.19 0-.29.09-.29.25s.05.42.22.78ZM365.09 275.06l-.84.03-.76-1.66-.11-.27-.12-.3c-.1.11-.16.17-.2.21l-.34.28-.57-.36.95-.77.69-.02 1.3 2.87ZM368.07 273.53c.23.51.29.88.19 1.13-.1.25-.39.38-.84.4-.43.01-.82-.1-1.16-.35-.34-.25-.61-.61-.84-1.1-.23-.51-.29-.89-.19-1.14.1-.25.38-.38.83-.39.43-.01.82.1 1.16.35.34.25.63.62.85 1.1Zm-1.85.05c.16.35.32.61.47.76.11.14.33.23.51.22.2 0 .29-.09.29-.25s-.06-.41-.22-.77c-.16-.35-.32-.61-.48-.76-.15-.15-.33-.23-.51-.22-.18 0-.29.09-.29.25s.05.41.22.77ZM371.06 274.88l-.77.02-.76-1.66-.12-.27-.12-.3c-.08.11-.14.17-.18.21l-.29.28-.54-.36.83-.77.63-.02 1.31 2.86ZM362.9 277.43c.17.37.21.64.14.82-.07.18-.27.27-.61.28-.28.02-.6-.07-.83-.25-.24-.18-.44-.45-.6-.8-.17-.37-.21-.64-.14-.83.07-.18.27-.27.6-.28.28-.02.6.08.84.25.24.19.45.45.61.8Zm-1.33.07c.12.26.23.44.34.55.1.12.29.19.44.15.09-.02.14-.09.13-.17 0-.11-.05-.3-.17-.56-.08-.19-.19-.38-.35-.56a.461.461 0 0 0-.44-.15h-.02c-.09.02-.14.09-.13.17.03.19.08.38.18.57ZM365.09 278.44l-.61.02-.55-1.21-.08-.2-.09-.22c-.07.08-.11.13-.14.15l-.24.2-.41-.25.67-.57h.49l.96 2.08ZM371.66 279.8c.17.37.21.64.13.82-.08.18-.28.27-.61.29-.28.02-.6-.07-.83-.25-.25-.18-.44-.44-.6-.8-.17-.37-.21-.64-.14-.82.07-.18.27-.27.6-.28.28-.02.6.07.84.25.26.18.46.45.62.8Zm-1.32.08c.12.25.22.44.34.55.1.12.29.18.43.15h.02c.09-.02.14-.09.13-.16 0-.11-.05-.3-.16-.55-.08-.19-.19-.38-.35-.55a.49.49 0 0 0-.37-.16c-.14 0-.23.07-.21.18 0 .11.05.29.17.55ZM373.86 280.8l-.6.02-.55-1.21-.08-.2-.09-.22c-.06.08-.11.13-.14.15l-.24.21-.41-.26.66-.57.49-.02.95 2.08ZM376.53 276.59c.23.51.29.88.19 1.13-.1.25-.39.38-.84.4-.43.01-.82-.1-1.16-.34-.34-.25-.62-.61-.84-1.09-.23-.51-.29-.89-.19-1.13.1-.25.38-.38.83-.4.43-.01.82.1 1.16.34.34.25.63.61.85 1.1Zm-1.85.06c.16.36.32.61.47.76.11.13.33.23.51.21.19 0 .29-.09.29-.25s-.06-.41-.22-.76c-.16-.35-.32-.61-.48-.76-.16-.15-.33-.23-.52-.22-.19 0-.29.09-.29.25s.07.43.24.78ZM379.65 277.96l-.84.03-.76-1.65-.12-.27-.12-.3c-.1.11-.16.17-.2.21l-.34.28-.57-.35.95-.77.69-.02 1.32 2.85ZM382.6 276.39c.23.5.29.88.19 1.12-.1.25-.39.38-.84.4-.44.02-.82-.1-1.16-.34-.34-.24-.62-.6-.84-1.09-.23-.5-.3-.88-.19-1.13.1-.25.38-.38.83-.39.43-.01.82.1 1.16.34.34.24.63.61.85 1.09Zm-1.85.06c.16.36.32.61.47.75.11.13.33.23.51.21.19 0 .29-.09.29-.25s-.06-.41-.22-.76c-.16-.35-.32-.61-.48-.76-.16-.15-.33-.23-.51-.22-.18 0-.29.09-.29.25s.07.42.23.77ZM371.11 264.31l-1.11.03-1.08-2.32-.17-.38-.18-.42c-.08.1-.17.19-.26.29l-.43.39-.78-.5 1.22-1.07.92-.02 1.86 4ZM375.34 262.18c.33.7.42 1.23.27 1.57-.15.34-.54.52-1.17.54-.61.02-1.15-.15-1.63-.49-.48-.34-.87-.85-1.18-1.53-.33-.71-.42-1.24-.28-1.58.14-.35.53-.52 1.16-.53.61-.01 1.15.15 1.63.5s.88.86 1.21 1.53Zm-2.6.06c.23.49.45.84.67 1.06.21.22.46.31.72.31.26 0 .4-.12.42-.34.02-.22-.09-.57-.33-1.07-.23-.5-.46-.85-.67-1.06-.22-.21-.46-.31-.71-.31-.26 0-.4.12-.42.34-.02.22.09.57.33 1.07Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.36 338.29s25.34 49.38 23.84 58.83c-1.5 9.45-28.59 39.37-28.59 39.37h-29.22s-12.2-14.89-12.2-28.2c0 0-19.11-6.87-12.67-31.14 0 0 2.58-57.32 58.84-38.86Z",
    style: {
      fill: "url(#ak)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.36 331.84v6.45s-45.53-17.19-58.84 38.86c0 0-75.35-11.6-102.53-45.31l-10.81-14.31s-15.97-67.86 69.2-68.87",
    style: {
      fill: "url(#al)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.84 288.83s-21.96-26.27-26.82-30.72l8.69 58.64L407 322s3.85-32.79 13.84-33.17",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.41 362.96s4.1-42.19 64.59-73.1l-33.93-25.34s-61.59 19.43-63.55 79.94c0 0 32.94 18.59 32.89 18.5Z",
    style: {
      fill: "url(#am)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#an)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411.18 277.18 325.01 410.17s54.28-14.26 84.81-85.99L463.36 233.8s-52.73.81-52.19 43.38Z",
    style: {
      fill: "url(#ao)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ap)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.47 841.48C433.5 893.68 329 899 329 899L163.45 314.01c14.92-55.59 76.82-25.68 77.84-25.19h.01l249.17 552.66Z",
    style: {
      fill: "url(#aq)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ar)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.84 288.83 609.31 633.6s-7.32 13.5-34.37 10.75L409.99 335.7s-12.24-39.19 10.85-46.87Z",
    style: {
      fill: "url(#as)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#at)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.19 591.65c-11.95 10.91-30.73 9.71-30.73 9.71L275.04 311.44l-1.17-2.15c11.34-26.26 63.36 8.5 63.95 8.9l126.37 273.46Z",
    style: {
      fill: "url(#au)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.3 288.83c-24.69 47.73-77.85 25.18-77.85 25.18 14.92-55.59 76.82-25.68 77.84-25.19h.01Z",
    style: {
      fill: "url(#av)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.18 277.18s31.96 2.84 45.62-12.76c13.66-15.59 6.57-30.62 6.57-30.62s-52.19-3.87-52.19 43.38Z",
    style: {
      fill: "url(#aw)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27 329.96s-50.53-.16-66.23-18.52-1.17-2.15-1.17-2.15c11.34-26.26 63.36 8.5 63.95 8.9l3.45 11.76Z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.84 288.83s-15.89 1.45-14.66 28.69c1.09 24.06 7.33 24.76 7.33 24.76s37.4-20.65 7.33-53.45Z",
    style: {
      fill: "url(#ax)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.45 314.01 29.81 155.32s87.56-14.98 122.03-41.5l-73.98-139s-57.3-30.83-77.85 25.18Z",
    style: {
      fill: "url(#ay)",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.18 277.18s85.68 140.99 96.85 138.68 84.16-58.86 85.14-83.2L463.36 233.8S412 230 411.17 277.18Z",
    style: {
      fill: "url(#az)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketman);
export default __webpack_public_path__ + "static/media/rocketman.bae93d9c8074f172e9d970e99485df15.svg";
export { ForwardRef as ReactComponent };